import type { audit as en } from '@/i18n/locales/en/audit';
import type { Translation } from '@/i18n/types';

export const audit: Translation<typeof en> = {
  page: {
    title: 'Denetim günlüğü',
    scopedLead:
      'Yalnızca kendi şirketleriniz için izin verilen eylemleri görürsünüz; rıza yanıtları ve kimlik bağlantıları asla dahil edilmez.',
    actionFilter: 'Eyleme göre filtrele',
    actionPlaceholder: 'eylem, örn. department.visibility.update',
    scopeFilter: 'Kapsama göre filtrele',
    scopePlaceholder: 'kapsam id’si',
    filter: 'Filtrele',
    empty: 'Denetim satırı yok.',
    when: 'Ne zaman',
    action: 'Eylem',
    actorRole: 'Kullanıcı rolü',
    target: 'Hedef',
    rowsLabel: 'denetim satırları',
  },
};
